import { ReactNode } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  Typography
} from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

export interface DetailsAccordionProps extends Omit<AccordionProps, 'title' | 'expanded'> {
  title?: ReactNode
}

export default function CardAccordion({ title, children, ...props }: DetailsAccordionProps) {
  return (
    <Accordion
      {...props}
      sx={{
        boxShadow: 0,
        '&:before': {
          display: 'none'
        },
        '&.Mui-expanded': {
          margin: 0
        },
        '& .MuiAccordionSummary-root': {
          borderRadius: 1,
          '&:hover': {
            backgroundColor: (theme) => theme.palette.action.hover
          }
        }
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />} sx={{ px: 4 }}>
        <Typography variant="h6">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 4 }}>{children}</AccordionDetails>
    </Accordion>
  )
}
